var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 830,
    viewBox: "0 0 430 830",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-719.429 143.67C-969.06 206.257 -1005.5 411.704 -1042.96 448.21L-774.76 802.315C-774.76 802.315 -598.543 -73.9633 -145.451 487.849C307.642 1049.66 615.937 748.74 615.937 748.74C700.964 17.0352 590.118 -133.126 544.914 105.826C494.79 370.784 224.603 448.21 -49.146 348.513C-362.418 234.422 -509.836 91.1217 -719.429 143.67Z",
    fill: "url(#paint0_linear_1_3742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3742",
    x1: -121.584,
    y1: 282.625,
    x2: -219.428,
    y2: 804.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC3EE",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6AD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector10);
export default __webpack_public_path__ + "static/media/vector10.a932e5ce599db9da646d4265d67d200c.svg";
export { ForwardRef as ReactComponent };